import React from 'react'

export default props => (
  <svg viewBox="0 0 14 15" {...props}>
    <path
      fillRule="evenodd"
      d="M4.6875,0.9375 C4.6875,0.42 5.03671875,0 5.46875,0 L8.59375,0 C9.02578125,0 9.375,0.42 9.375,0.9375 C9.375,1.455 9.02578125,1.875 8.59375,1.875 L5.46875,1.875 C5.03671875,1.875 4.6875,1.455 4.6875,0.9375 L4.6875,0.9375 Z M3.75,13.125 L10.3125,13.125 L10.3125,4.6875 L3.75,4.6875 L3.75,13.125 Z M11.25,2.8125 L2.8125,2.8125 L0.9375,2.8125 C0.4190625,2.8125 0,3.2325 0,3.75 C0,4.2675 0.4190625,4.6875 0.9375,4.6875 L1.875,4.6875 L1.875,14.0625 C1.875,14.58 2.2940625,15 2.8125,15 L11.25,15 C11.7684375,15 12.1875,14.58 12.1875,14.0625 L12.1875,4.6875 L13.125,4.6875 C13.6434375,4.6875 14.0625,4.2675 14.0625,3.75 C14.0625,3.2325 13.6434375,2.8125 13.125,2.8125 L11.25,2.8125 Z"
    />
  </svg>
)
